/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_LeadInputs */



/**
* | output |
* | --- |
* | "The core team in the UK, working with accredited Master Mariners and Chief Engineers around the world." |
*
* @param {Team_LeadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_lead = /** @type {((inputs?: Team_LeadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_LeadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("位于英国的核心团队，与世界各地的认证船长和轮机长合作。")
	return /** @type {LocalizedString} */ ("The core team in the UK, working with accredited Master Mariners and Chief Engineers around the world.")
});